import React from 'react';
import { useScroll } from 'react-router-scroll';
import { setLocale } from '@utils/date';

import { Router, applyRouterMiddleware } from 'react-router';
import routes from './routes';

import { ToastContainer, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import 'antd/dist/antd.css';

setLocale('ru');

class App extends React.Component {
  componentDidMount() {
    function loadCarrotQuestScript() {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.text = `!function () { function t(t, e) { return function () { window.carrotquestasync.push(t, arguments) } } if ("undefined" == typeof carrotquest) { var e = document.createElement("script"); e.type = "text/javascript", e.async = !0, e.src = "//cdn.carrotquest.io/api.min.js", document.getElementsByTagName("head")[0].appendChild(e), window.carrotquest = {}, window.carrotquestasync = [], carrotquest.settings = {}; for (var n = ["connect", "track", "identify", "auth", "oth", "onReady", "addCallback", "removeCallback", "trackMessageInteraction"], a = 0; a < n.length; a++)carrotquest[n[a]] = t(n[a]) } }(), carrotquest.connect("33627-d5709baf136724ee5f61370c72");`;
      document.head.appendChild(script);
    }
    if (process.env.REACT_APP_HOSTNAME === 'app.progkids.com')
      loadCarrotQuestScript();
  }
  render() {
    return (
      <>
        <ToastContainer transition={Flip} className="huge-toast-container" />
        <Router
          history={this.props.history}
          routes={routes(this.props)}
          render={applyRouterMiddleware(useScroll())}
        />
      </>
    );
  }
}

export default App;
